import localforage from 'localforage';
import { ICookieConsent } from '../components/CookieConsent/interfaces';
import { postRequest } from './HttpService';
import { clearLocalStoragePreservingAppKeys } from '../components/BESwitcher/BESwitcherStorage';

export const getUsername = (): string | null => {
  return localStorage.getItem('username');
};

export const getCustomerId = (): number | null => {
  const customerId = localStorage.getItem('customerId');
  if (!customerId) {
    return null;
  }
  return Number(customerId);
};

export const getUserId = (): number | null => {
  const userId = localStorage.getItem('userId');
  if (!userId) {
    return null;
  }
  return Number(userId);
};

export const getDriverId = (): number | null => {
  const driverId = localStorage.getItem('driverId');
  if (!driverId) {
    return null;
  }
  return Number(driverId);
};

export const getUserIdFromLocalForage = async (): Promise<number | null> => {
  const userId = await localforage.getItem<number>('userId');
  if (!userId) {
    return null;
  }
  return Number(userId);
};

export const getDriverIdFromLocalForage = async (): Promise<number | null> => {
  const driverId = await localforage.getItem<number>('driverId');
  if (!driverId) {
    return null;
  }
  return Number(driverId);
};

export const getUserEmail = (): string | null => {
  const userEmail = localStorage.getItem('userEmail');
  if (!userEmail) {
    return null;
  }
  return userEmail;
};

export const getFirstName = (): string | null => {
  const firstName = localStorage.getItem('firstName');
  if (!firstName) {
    return null;
  }
  return firstName;
};

export const getLastName = (): string | null => {
  const lastName = localStorage.getItem('lastName');
  if (!lastName) {
    return null;
  }
  return lastName;
};

export const setUserId = (id: number): void => {
  localforage.setItem('userId', Number(id));
  return localStorage.setItem('userId', String(id));
};

export const setDriverIdInIndexedDb = async (id: number | null): Promise<void> => {
  await localforage.setItem('driverId', id ? Number(id) : 0);
};

export const setDriverId = (id: number | null): void => {
  return localStorage.setItem('driverId', String(id));
};

export const setUserEmail = (email: string): void => {
  return localStorage.setItem('userEmail', email);
};

export const setFirstName = (firstName: string): void => {
  return localStorage.setItem('firstName', firstName);
};

export const setLastName = (lastName: string): void => {
  return localStorage.setItem('lastName', lastName);
};

export const setUsername = (username: string): void => {
  return localStorage.setItem('username', username);
};

export const setDefaultCustomer = (selectedCustomers: number[]): void => {
  return localStorage.setItem('defaultCustomer', JSON.stringify(selectedCustomers));
};

export const getDefaultCustomer = (): number[] => {
  const defaultCustomer = localStorage.getItem('defaultCustomer');
  if (defaultCustomer) {
    return JSON.parse(defaultCustomer);
  }
  return [];
};

export const setCustomerId = (customerId: number): void => {
  return localStorage.setItem('customerId', String(customerId));
};

export const setLanguage = (language: string): void => {
  return localStorage.setItem('language', language);
};

export const getLanguage = (): string => {
  const language = localStorage.getItem('language');

  if (language) {
    return language;
  }

  return '';
};

export const setSpeedLimitSettings = (settings: Record<string, any>): void => {
  return localStorage.setItem('speedLimitSettings', JSON.stringify(settings));
};

export const getSpeedLimitSettings = (): any => {
  const speedLimitSettings = localStorage.getItem('speedLimitSettings');
  if (speedLimitSettings) {
    return JSON.parse(speedLimitSettings);
  }
  console.warn("Configuration for speedlimits doesn't exists.");
  return null;
};

export const setCookieConsent = (cookieConsent: ICookieConsent | null): void => {
  localStorage.setItem('cookieConsent', cookieConsent ? JSON.stringify(cookieConsent) : '');
};

export const getCookieConsent = (): ICookieConsent | null => {
  const cookieConsent = localStorage.getItem('cookieConsent');
  return cookieConsent ? JSON.parse(cookieConsent) : null;
};

export const logOut = (): void => {
  const language = getLanguage();
  clearLocalStoragePreservingAppKeys();
  localforage.clear();
  setLanguage(language);
  window.location.href = '/';
};

export const autoLogout = (message: string): void => {
  const language = getLanguage();
  clearLocalStoragePreservingAppKeys({ autologoutMessage: message });
  localforage.clear();
  setLanguage(language);
  // window.location.href = '/?autologout=true';
  window.location.href = '/';
};

export const isLoggedIn = (): boolean => {
  const hasToken = localStorage.getItem('socketServerToken') !== null;
  const hasPermissions = localStorage.getItem('permissions') !== null;
  return hasToken && hasPermissions;
};

export const saveUserSettings = async (
  settingsKey: string,
  settings: Record<string, any>
): Promise<Record<string, any> | false> => {
  const response = await postRequest<Record<string, any>, Record<string, any>>(
    `v1/user-settings/${settingsKey}/save`,
    settings,
    {
      showErrorToaster: false,
      returnAxiosResponse: true,
    }
  );

  if (response && response.data) {
    return (response as Record<string, any>).data;
  }
  return false;
};
export const isDriver = (): boolean => {
  return JSON.parse(localStorage.getItem('driverId') ?? 'null') !== null;
};
